import React from 'react';

export interface ZoomControlProps {
  zoomLevel: number;
  onZoomChange: (zoom: number) => void;
}

/**
 * Controle de zoom do board (90%–110%) via transform scale no container.
 * @param props - Nível atual e callback de mudança
 */
export const ZoomControl: React.FC<ZoomControlProps> = ({ zoomLevel, onZoomChange }) => (
  <div className="px-2.5 py-2 mb-1 border-b border-slate-50">
    <p className="text-[9px] font-bold text-slate-400 uppercase tracking-widest mb-1.5">Zoom do Sistema</p>
    <div className="flex items-center justify-between gap-2 bg-slate-50 rounded-lg">
      <button
        type="button"
        onClick={() => zoomLevel > 90 && onZoomChange(zoomLevel - 10)}
        disabled={zoomLevel <= 90}
        className="size-6 flex items-center justify-center rounded-md bg-white border border-slate-200 text-slate-600 hover:text-primary-accent disabled:opacity-30 disabled:hover:text-slate-600 transition-colors shadow-sm"
        aria-label="Diminuir zoom"
      >
        <span className="material-symbols-outlined !text-[14px]">remove</span>
      </button>
      <span className="text-[10px] font-bold text-slate-600 w-8 text-center" aria-live="polite">
        {zoomLevel}%
      </span>
      <button
        type="button"
        onClick={() => zoomLevel < 110 && onZoomChange(zoomLevel + 10)}
        disabled={zoomLevel >= 110}
        className="size-6 flex items-center justify-center rounded-md bg-white border border-slate-200 text-slate-600 hover:text-primary-accent disabled:opacity-30 disabled:hover:text-slate-600 transition-colors shadow-sm"
        aria-label="Aumentar zoom"
      >
        <span className="material-symbols-outlined !text-[14px]">add</span>
      </button>
    </div>
  </div>
);
